module.exports = __webpack_public_path__ + "img/success.945123db.png";